import { fixFailedToExecuteRemoveChildOnNode } from '@systemeio/util'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './i18'
import './assets/styles/base.css'
import './index.css'
import '../../../../styles/colors.css'
import { configureStore } from './store'
import { parseUrl } from './utils/getIdFromUrl'
import { applyBrand, getBrand } from './utils/brand/get-brand'

const App = React.lazy(() => import('./App'))

fixFailedToExecuteRemoveChildOnNode()

//
;(async () => {
  const { id, isTemplate } = parseUrl()

  const rootElement = document.getElementById('root')

  if (!rootElement) throw new Error('Failed to find the root element')

  const root = createRoot(rootElement)

  const brand = await getBrand(true)

  if (!brand) {
    root.render(<div>Something went wrong</div>)
  }

  applyBrand(brand)

  if (!id) {
    window.location.assign('/dashboard/not-found')
  } else {
    root.render(
      <React.Suspense>
        <Provider store={configureStore()}>
          <App id={id} isTemplate={isTemplate} />
        </Provider>
      </React.Suspense>,
    )
  }
})()
